import storage from "@/lib/storage";
import api from "@shared/api/client";
import type { SocketAuth } from "@shared/types/socket";

const fetchSessionId = async (): Promise<string | null> => {
  try {
    const { sid } = await api.auth.session();
    return sid;
  } catch {
    return null;
  }
};

const getSocketAuth = async (): Promise<SocketAuth | undefined> => {
  const sid = await fetchSessionId();
  if (sid) return { sid };

  const token = await storage.getToken();
  if (token) return { token };

  return undefined;
};

export { fetchSessionId, getSocketAuth };
